<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange_"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad_">
               
              <template slot="menuLeft" slot-scope="scope">
                <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDelete">删 除</el-button>
              </template>
              <!-- <template slot="menuRight">
                <el-button type="primary"
                          size="small"
                          icon="el-icon-search"
                          @click="searchChange_">搜索
                </el-button>
                <el-button type="default"
                          size="small"
                          icon="el-icon-delete"
                          @click="searchReset">清空
                </el-button>
              </template> -->
               <template slot="projectIdForm" slot-scope="scope">
        <el-select
          :disabled='editMode'
          v-model="form.projectId"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value)=>projectChange_(value)"
        >
          <el-option
            v-for="item in projectList_"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdForm" slot-scope="scope">
        <el-select
          :disabled='editMode'
          v-model="form.areaId"
          placeholder="区域名称"
          style="width: 100%"
          @change="(value)=>areaChange_(value)"
        >
          <el-option
            v-for="item in areaList_"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      
          <!-- selectableRange: '00:00:00 - 24:00:00' -->
      <template slot="timeRangeForm" slot-scope="scope">
        <div style="display:flex;">
          <el-time-select
          style="flex:1"
    placeholder="起始时间"
    v-model="form.startTime"
    :picker-options="{
      start: '00:30',
      step: '00:15',
      end: '23:30'
    }">
  </el-time-select>
  <div>-</div>
  <el-time-select
          style="flex:1"
    placeholder="结束时间"
    v-model="form.endTime"
    :picker-options="{
      start: '00:30',
      step: '00:15',
      end: '23:30',
      minTime: form.startTime
    }">
  </el-time-select>
  </div>
      </template>

      <template slot="chargeInfosForm" slot-scope="scope">
        <div>
        <el-tabs v-model="form.workingDayFlag" @tab-click="handleClick">
          <el-tab-pane label="工作日" name="1">
            <el-row v-for="(item,index) in form.chargeInfos" :key="index">
              <el-col :span="12">
                <div style="display:flex">
                  <div style="flex:1;text-align:right;"><span style="color:red">*</span>时间段:</div>
                  <div style="flex:3">
                    
        
        <div style="display:flex;">
          <el-time-select
          style="flex:1"
    placeholder="起始时间"
    v-model="item.startTime"
    :picker-options="{
      start: '00:30',
      step: '00:15',
      end: '23:30'
    }">
  </el-time-select>
  <div>-</div>
  <el-time-select
          style="flex:1"
    placeholder="结束时间"
    v-model="item.endTime"
    :picker-options="{
      start: '00:30',
      step: '00:15',
      end: '23:30',
      minTime: item.startTime
    }">
  </el-time-select></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div style="display:flex">
                  <div style="flex:2;text-align:right;"><span style="color:red">*</span>租赁单价:</div>
                  <div style="flex:3">
                    <el-input size="small" placeholder="请输入租赁单价" v-model="item.price"></el-input>
                  </div>
                  <div style="flex:1;text-align:left;">/小时</div>
                  <div style="flex:1;">
                    <el-button type="primary" v-if="index>0&&showFormDelBtn" @click="deleteInfo(index)" style="">
                      删除
                    </el-button>
                    <div v-else>{{''}}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div style="padding:1rem 0;">
              <el-button type="primary" @click="addInfo" v-if="showFormDelBtn" icon="el-icon-plus" style="width:100%;">{{' '}}</el-button>
            </div>
          </el-tab-pane>


          <el-tab-pane label="非工作日" name="2">
            
            <el-row v-for="(item,index) in form._chargeInfos" :key="index">
              <el-col :span="12">
                <div style="display:flex">
                  <div style="flex:1;text-align:right;"><span style="color:red">*</span>时间段:</div>
                  <div style="flex:3">
                    
        
        <div style="display:flex;">
          <el-time-select
          style="flex:1"
    placeholder="起始时间"
    v-model="item.startTime"
    :picker-options="{
      start: '00:30',
      step: '00:30',
      end: '23:30'
    }">
  </el-time-select>
  <div>-</div>
  <el-time-select
          style="flex:1"
    placeholder="结束时间"
    v-model="item.endTime"
    :picker-options="{
      start: '00:30',
      step: '00:30',
      end: '23:30',
      minTime: item.startTime
    }">
  </el-time-select></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div style="display:flex">
                  <div style="flex:2;text-align:right;"><span style="color:red">*</span>租赁单价:</div>
                  <div style="flex:3">
                    <el-input size="small" placeholder="请输入租赁单价" v-model="item.price"></el-input>
                  </div>
                  <div style="flex:1;text-align:left;">/小时</div>
                  <div style="flex:1;">
                    <el-button type="primary" v-if="index>0&&showFormDelBtn" @click="deleteInfo_(index)" style="">
                      删除
                    </el-button>
                    <div v-else>{{''}}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div style="padding:1rem 0;">
              <el-button type="primary" @click="addInfo_" v-if="showFormDelBtn" icon="el-icon-plus" style="width:100%;">{{' '}}</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
          </div>
      </template>



      
               <template slot="projectIdSearch" slot-scope="scope">
        <el-select
          v-model="query.projectId"
          placeholder="项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdSearch" slot-scope="scope">
        <el-select
        clearable
          v-model="query.areaId"
          placeholder="区域名称"
          style="width: 100%"
          @change="(value)=>areaChange(value)"
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update, getAreaList, getVenueTypeList} from "@/api/v4ward/stadium-management/index";

  import {getProjectList} from "@/api/crmedical/project/project";

  export default {
    data() {
    var validatePassChargeInfos = (rule, value, callback)=>  {
      console.log('this.form====>',this.form);
      let validPassFlag = true;
      let validPassPriceFlag = true;
      this.form.chargeInfos.forEach((ele)=>{
        if(!ele.startTime||!ele.endTime){
          validPassFlag = false;
        }
        if(!ele.price){
          validPassPriceFlag = false
        }
      });
      
      this.form._chargeInfos.forEach((ele)=>{
        if(!ele.startTime||!ele.endTime){
          validPassFlag = false;
        }
        if(!ele.price){
          validPassPriceFlag = false
        }

      });
console.log(validPassPriceFlag,validPassFlag);
      if (!validPassFlag) {
        console.log('11111');
        callback(new Error('请输入时间段'));
      }else if(!validPassPriceFlag){
        console.log('22222');
        callback(new Error('请输入租赁单价'));
      } else {
        console.log('33333');
        callback();
      }
    };
    var validatePassTimeRange = (rule, value, callback)=>  {
      console.log('this.form====>',this.form);
      if (!this.form.startTime) {
        callback(new Error('请选择开始时间'));
      } else if (!this.form.endTime) {
        callback(new Error('请选择结束时间'));
      } else {
        callback();
      }
    };
      return {
        editMode:false,
        showFormDelBtn:false,
        timeRangeList:['',''],
        timeRangeList_:[],
        startTime:'',
        endTime:'',
        areaList:[],
        projectList:[],
        areaList_:[],
        projectList_:[],
        form: {
          startTime:'',
          endTime:'',
          chargeInfos:[{
            startTime:'',
            endTime:'',
            price:'',
            workingDayFlag:'1',
            timeRange:[new Date(),new Date()],
          }],
          _chargeInfos:[{
            startTime:'',
            endTime:'',
            price:'',
            workingDayFlag:'2',
            timeRange:[new Date(),new Date()],
          }],
          timeRange:{
            startTime:'',
            endTime:''
          }, 
          workingDayFlag:'1'
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 90,
          searchShow: true,
          // searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel:"序号",
          editBtn: true,
          viewBtn: true,
          addBtn:true,
          selection: true,
          dialogClickModal: false,
          // emptyBtn:false,
          // searchBtn:false,
          // columnBtn:false,
          // searchShowBtn:false,
          // refreshBtn:false,
          column: [
            {
              label: "项目名称",
              prop: "projectName",
              search: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "区域名称",
              prop: "areaName",
              search: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "项目名称",
              prop: "projectId",
              hide:true,
              searchslot:true,
              searchClearable: false,
              formslot:true,
              search: true,
              type: 'tree',
              span:8,
              props: {
                label: 'name',
                value: 'id',
              },
              rules: [{
                required: true,
                message: "请输入项目名称",
                trigger: "blur"
              }]
            },
            {
              label: "区域名称",
              prop: "areaId",
              hide:true,
              span:8,
              search:true,
              searchslot:true,
              formslot:true,
              rules: [{
                required: true,
                message: "请输入区域名称",
                trigger: "change"
              }]
            },
            {
              label: "场馆类型",
              prop: "type",
              span:8,
              search:true,
              type: 'select',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=venue_type',
              rules: [{
                required: true,
                message: "请输入场馆类型",
                trigger: "change"
              }]
            },
            {
              label: "场馆名称",
              prop: "name",
              span:8,
              search:true,
              maxlength:30,
              rules: [{
                required: true,
                message: "请输入场馆名称",
                trigger: "blur"
              }]
            },
            {
              label: "可容纳人数",
              labelWidth: 95,
              prop: "capactity",
              span:8,
              search:false,
              maxlength:5,
              rules: [{
                required: true,
                message: "请输入可容纳人数",
                trigger: "blur"
              }]
            },
            {
              label: "开始时间",
              prop: "startTime",
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "结束时间",
              prop: "endTime",
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "营业时间段",
              prop: "timeRange",
              hide:true,
              labelWidth: 95,
              span:16,
              search:false,
              formslot:true,
              rules: [{
                validator: validatePassTimeRange,
                required: true,
                message: "请输入营业时间段",
                trigger: "blur"
              }]
            },

            {
              label: "场馆设施",
              prop: "facility",
              span:24,
              search:false,
              maxlength:50,
              // rules: [{
              //   required: true,
              //   message: "请输入场馆设施",
              //   trigger: "blur"
              // }]
            },
            {
              label: "场馆地址",
              prop: "address",
              span:24,
              search:false,
              maxlength:50,
              // rules: [{
              //   required: true,
              //   message: "请输入场馆地址",
              //   trigger: "blur"
              // }]
            },
            {
              label: "场馆说明",
              prop: "description",
              span:24,
              search:false,
              maxlength:50,
              // rules: [{
              //   required: true,
              //   message: "请输入场馆说明",
              //   trigger: "blur"
              // }]
            },
            {
              label: "",
              prop: "chargeInfos",
              labelWidth: 0,
              span:24,
              formslot:true,
              search:false,
              hide:true,
              rules: [{
                validator: validatePassChargeInfos,
                required: true,
                // message: "请输入时间段",
                trigger: "blur"
              }]
            },

            

          ]
        },
        data: []
      };
    },
    created(){
      getProjectList().then((res)=>{
        this.projectList = res.data;
        this.projectList_ = res.data;
        this.query.projectId = res.data[0].id;
      })
    },
    mounted(){
      window.onresize=()=>{
        this.$refs.crud.doLayout();
      }
      console.log();
      this.$refs.crud.$refs.headerMenu.$children[6].$el.style.display='none'
    },
    activated(){
      window.onresize=()=>{
        this.$refs.crud.doLayout();
      }
      this.$refs.crud.doLayout();
    },
    computed: {
    },
    methods: {
      delListAction(){
        let ids = '';
        let idList = [];

        if(this.selectionList&&this.selectionList.length>0){
          remove({ids:ids})
        }
      },
      deleteInfo(index){
        this.form.chargeInfos.splice(index,1)
      },
      addInfo(){
        let self = this;
        this.form.chargeInfos.push({
          startTime:'',
          endTime:'',
          price:'',
          workingDayFlag:self.form.workingDayFlag
        });
      },
      
      deleteInfo_(index){
        this.form._chargeInfos.splice(index,1)
      },
      addInfo_(){
        let self = this;
        this.form._chargeInfos.push({
          startTime:'',
          endTime:'',
          price:'',
          workingDayFlag:self.form.workingDayFlag
        });
      },
      handleClick(tab, event) {
        console.log(tab, event);
        console.log(tab.name);
      },
      projectChange(value){
        this.query.projectId = value;
        this.query.areaId = '';
        getAreaList({ projectId: value }).then(({ data })=>{
          console.log("getAreaList=====>",data);
          this.areaList = data;
        });
        this.$forceUpdate();
      },
      projectChange_(value){
        this.form.projectId = value;
        this.form.areaId = '';
        getAreaList({ projectId: value }).then(({ data })=>{
          console.log("getAreaList=====>",data);
          this.areaList_ = data;
        });
        this.$forceUpdate();
      },
      areaChange(value){
        this.query = Object.assign({},this.query,{
          areaId:value
        });
      },
      areaChange_(value){
        this.form = Object.assign({},this.form,{
          areaId:value
        });
      },
      rowSave(row, done, loading) {
        console.log(row);
        // row.startTime = row.timeRange.startTime;
        // row.endTime = row.timeRange.endTime;
        // return;
        
        let chargeInfosList = [];
        row._chargeInfos.forEach(element => {
          chargeInfosList.push({
            price:element.price,
            startTime:element.startTime,
            endTime:element.endTime,
            workingDayFlag:2,
          })
        });
        row.chargeInfos.forEach(element => {
          chargeInfosList.push({
            price:element.price,
            startTime:element.startTime,
            endTime:element.endTime,
            workingDayFlag:1,
          })
        });
        let addForm = {
          projectId:row.projectId||'',
          areaId:row.areaId||'',
          type:row.type||'',
          name:row.name||'',
          capactity:row.capactity||'',
          facility:row.facility||'',
          address:row.address||'',
          description:row.description||'',
          remark:row.remark||'',
          startTime:row.startTime,
          endTime:row.endTime,
          chargeInfos:chargeInfosList,
          workingDayFlag:row.workingDayFlag
        }
        add(addForm).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        let chargeInfosList = [];
        row._chargeInfos.forEach(element => {
          chargeInfosList.push({
            price:element.price,
            startTime:element.startTime,
            endTime:element.endTime,
            workingDayFlag:2,
          })
        });
        row.chargeInfos.forEach(element => {
          chargeInfosList.push({
            price:element.price,
            startTime:element.startTime,
            endTime:element.endTime,
            workingDayFlag:1,
          })
        });
        let updateForm = {
          id:row.id||'',
          projectId:row.projectId||'',
          areaId:row.areaId||'',
          type:row.type||'',
          name:row.name||'',
          capactity:row.capactity||'',
          facility:row.facility||'',
          address:row.address||'',
          description:row.description||'',
          remark:row.remark||'',
          startTime:row.startTime,
          endTime:row.endTime,
          chargeInfos:chargeInfosList,
          workingDayFlag:row.workingDayFlag
        }
        update(updateForm).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm(
          "<div>删除说明:</div><div>1、确认后将同步删除该场馆的关联数据。</div><div>2、该操作不可逆，数据无法找回，请谨慎操作。</div>",
          "是否确定删除当前场馆?", 
           {
          dangerouslyUseHTMLString:true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        
        let ids = '';
        let idList = [];

        this.selectionList.forEach((element)=>{
            idList.push(element.id);
        });

        ids = idList.join(',');


        this.$confirm(
          "<div>删除说明:</div><div>1、确认后将同步删除该场馆的关联数据。</div><div>2、该操作不可逆，数据无法找回，请谨慎操作。</div>",
          "是否确定删除当前场馆?", 
          {
          dangerouslyUseHTMLString:true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        let self = this;
        this.editMode = false;
        if(['add'].includes(type)){
          this.showFormDelBtn = true;
          let projectId = this.query.projectId;
          this.form = Object.assign({},this.form,{
            name:'',
            type:'',
            projectId:projectId,
            areaId:'',
            capactity:'',
            facility:'',
            address:'',
            description:'',
            startTime:'',
            endTime:'',
            chargeInfos:[{
              startTime:'',
              endTime:'',
              price:'',
              workingDayFlag:1
            }],
            _chargeInfos:[{
              startTime:'',
              endTime:'',
              price:'',
              workingDayFlag:2
            }],
            timeRange:{
              startTime:'',
              endTime:''
            }, 
            workingDayFlag:'1'
          });
          getAreaList({projectId:self.query.projectId}).then((res)=>{
            this.areaList_ = res.data;
          }); 
        }
        if (["edit", "view"].includes(type)) {
        this.editMode = true;
          if(["view"].includes(type)){
            this.showFormDelBtn = false;
          }else{
            this.showFormDelBtn = true;
          }
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            this.form.timeRange = {
              startTime: data.startTime,
              endTime: data.endTime,
            }
            this.form.workingDayFlag = '1';
            let _chargeInfos = [];
            let chargeInfos = [];
            this.form.chargeInfos.forEach(ele=>{
              if(parseInt(ele.workingDayFlag)==1){
                chargeInfos.push(ele);
              }
              if(parseInt(ele.workingDayFlag)==2){
                _chargeInfos.push(ele);
              }
            });
            this.form.chargeInfos = chargeInfos;
            this.form._chargeInfos = _chargeInfos;
            console.log('getDetail========>',data);
            getAreaList({ projectId: data.projectId }).then(({ data })=>{
              this.areaList = data;
              this.areaList_ = data;
            });
          });
        }
        done();
      },
      searchReset() {
        let projectId = this.query.projectId;
        this.query = {};
        this.query.projectId = projectId;
        // this.query.projectId = this.projectList[0].id;
        this.query.type = this.venueTypeList[0].dictKey;
        this.getAreaList(this.query.projectId);
        this.$refs.crud.$refs.headerSearch.searchForm.type=this.venueTypeList[0].dictKey;
        this.$refs.crud.$refs.headerSearch.searchForm.name='';
        this.onLoad();
      },
      searchChange_(params, done){
        this.query.type = this.$refs.crud.$refs.headerSearch.searchForm.type;
        this.query.name = this.$refs.crud.$refs.headerSearch.searchForm.name;
        console.log('searchChange====>',this.$refs.crud);
        console.log('searchChange====>',this.query);
        this.query = Object.assign({},this.query,{});
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      searchChange(params, done) {
        console.log('searchChange====>',params);
        
        console.log('searchChange====>',this.query);
        this.query = Object.assign({},this.query,params);
        // this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
        console.log('this.selectionList======>',this.selectionList);
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      getAreaList(projectId){
        getAreaList({projectId:projectId}).then((res)=>{
          this.areaList = res.data;
          this.areaList_ = res.data;
        });
      },
      onLoad_(page){
        page = page || this.page;
        this.loading = true;
        getVenueTypeList().then(({data})=>{
          this.venueTypeList = data;
        this.$refs.crud.$refs.headerSearch.searchForm.type=this.venueTypeList[0].dictKey;
          getProjectList().then((res)=>{
            this.projectList = res.data;
            this.projectList_ = res.data;
            this.query.projectId = res.data[0].id;
            this.query.type = this.venueTypeList[0].dictKey;
            getAreaList({projectId:res.data[0].id}).then((res)=>{
              this.areaList = res.data;
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            });
          })
        })
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total||0;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>
